<template lang="pug">
  .map
    iframe(
      v-if="configured"
      width="100%"
      height="400"
      frameborder="0"
      style="border: 0"
      allowfullscreen
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
      :src="`https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${location.street1}+${location.city}+${location.state}+${location.zip}`"
    )
</template>

<script>
  import { toRefs } from 'vue'
  import { googleMapsConfig, googleMapsConfigured } from '../../utils/google_config'

  export default {
    props: {
      location: {
        type: Object,
        required: true
      }
    },

    setup(props) {
      const apiKey = googleMapsConfig()?.apiKey
      const { location } = toRefs(props)

      return {
        apiKey,
        location,
        configured: googleMapsConfigured()
      }
    }
  }
</script>
